'use strict';

class product_sliders {
    constructor() {
        // Check if sliders are already initialized to prevent double initialization
        if ($('.gallery-view ul').hasClass('bxSlider-initialized')) {
            return
        }
        if ($('.gallery-view-mob ul').hasClass('bxSlider-initialized')
        ) {
            return
        }

        /**
         * Инициализация десктопного слайдера (вертикальный)
         */
        let galleryView = $('.gallery-view ul').bxSlider({
            mode: 'vertical',
            startSlide: 0,
            nextText: '',
            prevText: '',
            pagerCustom: '.gallery-thumbs',
            speed: 100,
            preloadImages: 'visible',
            infiniteLoop: false,
            controls: true,
            responsive: true,
            touchEnabled: false,
            shrinkItems: true,
            onSliderLoad: () => {
                // Показать элементы слайдера после загрузки
                $('.product .gallery-view_item').css('visibility', 'visible')
            },
        }).addClass('bxSlider-initialized');

        /**
         * Инициализация мобильного слайдера (горизонтальный)
         */
        let galleryViewMob = $('.gallery-view-mob ul').bxSlider({
            mode: 'horizontal',
            nextText: '',
            prevText: '',
            infiniteLoop: false,
            speed: 100,
            pager: $('.gallery-view-mob li').length > 1,
            adaptiveHeight: true,
            responsive: true,
            touchEnabled: true,
            shrinkItems: true,
            controls: false,
            onSliderLoad: () => {
                // Показать элементы слайдера после загрузки и установить высоту
                $('.product .gallery-view_item').css('visibility', 'visible')
                $('.gallery-view-mob .bx-viewport').height(window.innerWidth) // Установка высоты вьюпорта
            }
        }).addClass('bxSlider-initialized');

        // Получение данных о продукте для связки с попапом галереи
        let productData = document.querySelector('[data-product]')
        let popupGallery // Переменная для попапа галереи
        let elementId // ID элемента продукта
        if (productData) {
            let dataProduct = JSON.parse(productData.dataset.product)
            elementId = dataProduct[0]
            popupGallery = $('#gallery-' + elementId)
            // Инициализация попапа
            popupGallery.popup({
                scrolllock: true,
                opentransitionend: () => {
                    // Перерисовка слайдера в попапе после его открытия
                    galleryView2.redrawSlider()
                }
            })
        }

        // Инициализация слайдера в попапе
        let galleryView2 // Переменная для слайдера в попапе
        let popupSlider = popupGallery.find('.gallery-popup__slider')
        if (!popupSlider.hasClass('bxSlider-initialized')) {
            galleryView2 = popupSlider.bxSlider({
                startSlide: 0,
                nextText: '',
                prevText: '',
                speed: 100,
                pager: $('#gallery-' + elementId + ' .gallery-popup__slider li').length > 1, // Показывать пейджер, если больше одного слайда
                infiniteLoop: false,
                responsive: true,
                touchEnabled: true,
                keyboardEnabled: true,
                shrinkItems: true
            }).addClass('bxSlider-initialized');
        } else {
            // Если слайдер уже инициализирован, используем существующий экземпляр
            galleryView2 = popupSlider
        }

        // Обработчик наведения на миниатюры для навигации по десктопному слайдеру
        $('.gallery-thumbs a').each(function (i, el) {
            $(el).attr({
                'data-slide-index': i
            })
        })

        // Обработчик клика по элементу десктопной галереи для открытия попапа и синхронизации слайда
        $('.gallery-view .gallery-view_item__link').click(() => {
            // Получить текущий слайд десктопного слайдера
            let count = galleryView.getCurrentSlide()
            // Перейти на соответствующий слайд в попап слайдере
            galleryView2.goToSlide(count)
        })


        // Обработчик изменения размера окна для перерисовки мобильного слайдера и установки высоты
        $(window).on('resize', () => {
            let gh = $('.gallery-view .bx-viewport ul li:nth-child(2)').height()
            $('.gallery-inside').height(gh) // Установка высоты контейнера галереи
            galleryViewMob.redrawSlider() // Перерисовка мобильного слайдера
        })

        // Обработчик клика по элементу мобильной галереи для открытия попапа и синхронизации слайда
        $('.gallery-view-mob .gallery-view_item').click(() => {
            // Получить текущий слайд мобильного слайдера
            let count = galleryViewMob.getCurrentSlide()
            // Перейти на соответствующий слайд в попап слайдере
            galleryView2.goToSlide(count)
        })

        // Обработчик клика по кнопке закрытия галереи в попапе
        $('.gallery-' + elementId + '_close.popup_close').click(() => {
            // Получить текущий слайд попап слайдера
            let count = galleryView2.getCurrentSlide()
            // Перейти на соответствующий слайд в десктопном и мобильном слайдерах
            galleryView.goToSlide(count)
            galleryViewMob.goToSlide(count)
        })

        // Обработчик клика по кнопке 360 для перехода к последнему слайду в десктопном и мобильном слайдерах
        $('.round-icon-buttons__item[id^="view360-"]').click(() => {
            // Перейти к последнему слайду (предполагается, что там находится 360 обзор)
            galleryView.goToSlide(galleryView.getSlideCount() - 1)
        })
    }
}

export default product_sliders;